import React from "react";

const About = () => {
  return (
    <section
      id="about"
      className="w-screen py-12 px-6 md:pt-24 md:pb-12 md:px-16"
    >
      <div className="max-w-5xl md:mx-auto flex flex-col gap-4 md:gap-6">
        <div className="grid md:grid-cols-3 gap-4">
          <div className="bg-gray-100 border border-gray-200 rounded-xl text-center p-4">
            <i className="bx bx-award text-2xl text-blue-600 mb-2"></i>
            <h3 className="text-lg font-semibold">
              3 Years Working Experiences
            </h3>
          </div>
          <div className="bg-gray-100 border border-gray-200 rounded-xl text-center p-4">
            <i className="bx bx-briefcase-alt text-2xl text-blue-600 mb-2"></i>
            <h3 className="text-lg font-semibold">Completed 20+ Projects </h3>
          </div>
          <div className="bg-gray-100 border border-gray-200 rounded-xl text-center p-4">
            <i className="bx bx-trophy text-2xl text-blue-600 mb-2"></i>
            <h3 className="text-lg font-semibold">
              Received 12 Honors and Awards
            </h3>
          </div>
        </div>
        <div className="bg-gray-50 border border-gray-200 rounded-xl text-center p-6">
          <h3 className="text-lg font-normal ">
            I am skillful with approaching problems and developing innovative
            solutions using creativity. I gain most of my technical and
            professional experiences from doing an internship, working for tech
            and telecom company, building own startup, and joining
            extra-curricular activities. Helping others and empowering people is
            what motivates me the most as a person. <br /> <br /> In workplace,
            I love to see the team that is working collaboratively, sharing the
            same vision, and not only understand how they can contribute but how
            important they are to a team’s success.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default About;
